import React from 'react';

const ErrorBlock = (props) => {
  const { error } = props;
  if (
    error &&
    error.data &&
    error.data.errors &&
    error.data.errors.length &&
    props.error.data.errors[0]
  ) {
    return (
      <div className="alert alert-danger" role="alert">
        <i className="mdi mdi-block-helper mr-2"></i>
        {props.error.data.errors[0].message}
      </div>
    );
  } else {
    return null;
  }
};

export default ErrorBlock;
